import React from "react"
import {Grid, Modal, TransitionablePortal} from "semantic-ui-react"
import {FormattedMessage, useIntl} from "react-intl"


type ContactFormProps = {
    open: boolean
    onClose: () => void
}

export function MoreRelativesModal({ open, onClose }: ContactFormProps) {
    const intl = useIntl()
    return (
        <TransitionablePortal open={open} transition={{ animation: "fade", duration: 500 }}>
        <Modal className="more-relatives" closeIcon open={open} onClose={onClose} size="fullscreen" dimmer="inverted">
            <Modal.Header style={{ marginTop: 10, paddingBottom: 0 }}>
                <h1><FormattedMessage id="morerelatives.header"/></h1>
            </Modal.Header>
            <Modal.Content style={{ paddingTop: 10, marginBottom: 10 }}>
                <p>
                    <span style={{fontWeight: "bold", fontSize: 17}}><FormattedMessage id="morerelatives.short.answer"/></span>&nbsp;
                    <FormattedMessage id="morerelatives.trees.complicated"/>&nbsp;😅
                </p>

                <p className="centered-block" style={{ marginTop: 0, marginBottom: 30 }}>
                    <FormattedMessage id="morerelatives.better.example"/>
                </p>

                <Grid columns={3}>
                    {/* Hourglass basic scenario */}
                    <Grid.Column>
                        <p>
                            <FormattedMessage id="morerelatives.col1.ego" values={{
                                ego: <>"<span style={{ fontWeight: "bold", color: "var(--creator-indi-yellow-active)", fontSize: 17 }}>ego</span>"</>
                            }}/><br/><br/>
                            <FormattedMessage id="morerelatives.col1.representation" values={{
                                hourglass: <span style={{ fontWeight: "bold", fontSize: 17 }}>
                                    <FormattedMessage id="morerelatives.short.hourglass"/>
                                </span>
                            }}/>&nbsp;⏳
                        </p>
                        <div><img src={`/assets/more-relatives/${intl.locale}/hourglass.svg`} alt="Hourglass basic scenario"/></div>
                    </Grid.Column>
                    {/* Spouse family */}
                    <Grid.Column>
                        <p>
                            <FormattedMessage id="morerelatives.col2.spouse" values={{
                                indiId: <span style={{ fontWeight: "bold", backgroundColor: "var(--react-table-female)", fontSize: 17 }}>I7</span>
                            }}/><br/><br/>
                            <FormattedMessage id="morerelatives.col2.competing" values={{
                                requiresSpace: <span style={{ fontWeight: "bold", fontSize: 17 }}>
                                    <FormattedMessage id="morerelatives.col2.require.space"/>
                                </span>
                            }}/>
                        </p>
                        <div><img src={`/assets/more-relatives/${intl.locale}/more-relatives-1.svg`} alt="Spouse family"/></div>
                    </Grid.Column>
                    {/* Second marriage */}
                    <Grid.Column>
                        <p>
                            <FormattedMessage id="morerelatives.col3.remarried" values={{
                                indiId: <span style={{ fontWeight: "bold", backgroundColor: "var(--react-table-female)", fontSize: 17 }}>I5</span>
                            }}/><br/><br/>
                            <FormattedMessage id="morerelatives.col3.messy" values={{
                                atOnce: <span style={{ fontWeight: "bold", fontSize: 17 }}>
                                    <FormattedMessage id="morerelatives.col3.at.once"/>
                                </span>
                            }}/>
                        </p>
                        <div><img src={`/assets/more-relatives/${intl.locale}/more-relatives-2.svg`} alt="Second marriage"/></div>
                    </Grid.Column>
                </Grid>

                <div id="pruning-trees">
                    <img src="/assets/more-relatives/tree.png" alt="Prunning trees"/>
                    <p>
                    <FormattedMessage id="morerelatives.footer.scenarios"/><br/><br/>
                    <FormattedMessage id="morerelatives.footer.solution" values={{
                        prune: <span style={{ fontWeight: "bold", fontSize: 17 }}>
                            <FormattedMessage id="morerelatives.footer.prune"/>
                        </span>
                    }}/>
                    <br/><br/>
                    <span className="footer-centered">
                        <FormattedMessage id="morerelatives.footer.angle" values={{
                            angle: <span style={{ fontWeight: "bold", fontSize: 17 }}>
                                <FormattedMessage id="morerelatives.footer.angle.placeholder"/>
                            </span>
                        }}/>&nbsp;🌳
                    </span>
                    </p>
                </div>

            </Modal.Content>
        </Modal>
        </TransitionablePortal>
    )
}